export const overviewPage = {
  hero: {
    title: 'AI writes code fast. You spend the next hour fixing what it got wrong.',
    subline:
      'Standards become constraints. Plans become contracts. Execution becomes visible. Patterns surface across runs.',
    actions: [
      { label: 'See a real run →', to: '/demo' },
      { label: 'Open console →', to: '/console', primary: true },
    ],
  },

  pillars: {
    label: '',
    heading: 'What Proof Does',
    panels: [
      {
        title: 'Your standards enforced, not suggested.',
        copy: 'Before writing code, the AI looks up your project’s standards and works against a checklist it must satisfy.',
        screenshot: {
          src: '/demo/landing-standards.svg',
          alt: 'Standards lookup returning structured requirements.',
        },
      },
      {
        title: 'Plan approved before code written.',
        copy: 'Unlike chat planning mode, the approved plan is the execution contract. Not a suggestion.',
        screenshot: {
          src: '/demo/landing-control.svg',
          alt: 'Approval gate between plan and execution.',
        },
      },
      {
        title: 'Patterns across runs, not just one.',
        copy: 'What keeps breaking, which standards are working: surfaced, not buried in chat history.',
        screenshot: {
          src: '/demo/landing-cross-run.svg',
          alt: 'Recurring gaps from recent runs aggregated into a single cross-run signal.',
        },
      },
    ],
  },

  howItWorks: {
    label: 'How It Works',
    heading: 'Describe. Plan. Execute. Review.',
    steps: [
      {
        number: '01',
        title: 'Describe the work',
        copy: 'A feature, a bug fix, a design doc. Or a plan you’ve already drafted in Claude Code or Cursor.',
        screenshot: {
          src: '/demo/landing-step-1.svg',
          alt: 'Request submission with workspace context.',
        },
      },
      {
        number: '02',
        title: 'Review the plan',
        copy: 'Proof turns the request into ordered steps. You approve before anything runs.',
        screenshot: {
          src: '/demo/landing-step-2.svg',
          alt: 'Plan with step types, dependencies, and approval control.',
        },
      },
      {
        number: '03',
        title: 'Watch it execute',
        copy: 'Each step runs with the standards and tools it needs. If step five fails, steps one through four are preserved.',
        screenshot: {
          src: '/demo/landing-step-3.svg',
          alt: 'Execution view with steps in different states.',
        },
      },
      {
        number: '04',
        title: 'Review the result',
        copy: 'Diffs, tests, transcripts, diagnostics. Attached to the run, reviewable months later.',
        screenshot: {
          src: '/demo/landing-step-4.svg',
          alt: 'Results view with code changes, tests, and diagnostics.',
        },
      },
    ],
  },

  learningSignals: {
    label: 'Show Me',
    heading: 'Recurring gaps don’t recur silently.',
    copy: 'If catch-log-continue appears in 7 of your last 20 runs, Proof surfaces it. You write the standard. Future runs show whether it keeps recurring.',
    screenshot: {
      src: '/demo/landing-learning-signals.png',
      alt: 'Learning Signals panel listing recurring gap topics seen across recent runs.',
    },
  },

  close: {
    thesis: [
      'Standards become constraints.',
      'Plans become contracts.',
      'Execution becomes visible.',
      'Patterns surface across runs.',
    ],
    actions: [
      { label: 'Open the console →', to: '/console', primary: true },
      { label: 'Go deeper →', to: '/system' },
    ],
  },
}
